import { render, staticRenderFns } from "./SubscribeV2.vue?vue&type=template&id=980ae648"
import script from "./SubscribeV2.vue?vue&type=script&lang=js"
export * from "./SubscribeV2.vue?vue&type=script&lang=js"
import style0 from "./SubscribeV2.vue?vue&type=style&index=0&id=980ae648&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports